import { render, staticRenderFns } from "./SpectrumList.vue?vue&type=template&id=5440d57a&scoped=true"
import script from "./SpectrumList.vue?vue&type=script&lang=js"
export * from "./SpectrumList.vue?vue&type=script&lang=js"
import style0 from "./SpectrumList.vue?vue&type=style&index=0&id=5440d57a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5440d57a",
  null
  
)

export default component.exports